<div *ngIf="!isLoading && !hideElement" class="mb-1 d-flex" data-test-id="drop-down-content">
  <div ngbDropdown class="d-inline-block width-200">
    <button ngbDropdownToggle data-test-id="filter-button" type="button" class="filter-btn">
      {{ filter.name | translate }} {{ selectedFilter.title | translate }}
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownMenu" autoClose="true" class="dropdown-menu-right width-200">
      <ng-container *ngFor="let option of filter.options; index as index">
        <button
          type="button"
          [attr.data-test-id]="'filter-button-' + index"
          (click)="onFilterSelect(option)"
          ngbDropdownItem
        >
          {{ option.title | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
